// counter.actions.ts
import { Action } from '@ngrx/store';

export const FETCH = '[Companies] FETCH';
export const FETCH_SUCCESS = '[Companies] FETCH_SUCCESS';
export const FUZZY_FETCH = '[Companies] FUZZY_FETCH';
export const FUZZY_FETCH_SUCCESS = '[Companies] FUZZY_FETCH_SUCCESS';
export const FUZZY_FETCH_FAILURE = '[Companies] FUZZY_FETCH_FAILURE';
export const RESET = '[Companies] RESET';

export class Reset implements Action {
  readonly type = RESET;
  constructor() {}
}

export class Fetch implements Action {
  readonly type = FETCH;
  constructor(public payload: object) {}
}

export class FetchSuccess implements Action {
  readonly type = FETCH_SUCCESS;
  constructor(public payload: any) {}
}

export class FuzzyFetch implements Action {
  readonly type = FUZZY_FETCH;
  constructor(public payload: string) {}
}

export class FuzzyFetchSuccess implements Action {
  readonly type = FUZZY_FETCH_SUCCESS;
  constructor(public payload: any) {}
}
export class FuzzyFetchFailure implements Action {
  readonly type = FUZZY_FETCH_FAILURE;
  constructor(public payload: any) {}
}

export type Actions = Reset | Fetch | FetchSuccess | FuzzyFetch | FuzzyFetchSuccess | FuzzyFetchFailure;



// WEBPACK FOOTER //
// ./src/actions/companies.actions.ts